import { render, staticRenderFns } from "./AlertManagement.vue?vue&type=template&id=0bbe4e08&scoped=true&"
import script from "./AlertManagement.vue?vue&type=script&lang=js&"
export * from "./AlertManagement.vue?vue&type=script&lang=js&"
import style0 from "./AlertManagement.vue?vue&type=style&index=0&id=0bbe4e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe4e08",
  null
  
)

export default component.exports